import "../KidInfo/Quests.css";
import "./Settings.css";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import UpdatePasswordForm from "./Security";
import BackButton from "../Goback/GoBack";

export const SchlParentSettings = () => {
  const { user } = useAuth();
  const storedUser = JSON.parse(localStorage.getItem("tenant-user"));
  const finalUser = user || storedUser;

  return (
    <div className="dashboardBody">
      <div className="container-fluid p-0">
        <div className="p-0" id="mainContent">
          <div className="teacher-bodycontent mb-4">
            <section>
              <div className="container-fluid">
                <div className="row mb-4">
                  <div className="col-md-12">
                    <BackButton />
                  </div>
                  <div className="col-md-12 justify-content-center align-self-center">
                    <p className="tchrdashboard-cmntitl mb-0">
                      Account Settings
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className="adminform-layout mt-4"
                      style={{ padding: "0px" }}
                    >
                      <div className="tab-content" id="myTabContent">
                        <div style={{ padding: "40px" }}>
                          <div className="row">
                            <div className="col-md-12">
                              <p className="settingTitl">
                                {finalUser?.user?.firstName ||
                                  finalUser?.firstName || finalUser?.name ||
                                  "User Name Not Found"}
                              </p>
                              <div className="row">
                                <label
                                  htmlFor="email"
                                  className="col-form-label col-12 col-md-3 addSchlAcuntFormLabelKids"
                                >
                                  Email
                                </label>
                                <div className="col-12 col-md-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    value={finalUser?.user?.email || finalUser?.email}
                                    disabled
                                  />
                                </div>
                              </div>
                              <UpdatePasswordForm />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
